import React from 'react';
import { styled } from '@mui/material/styles';
import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';
import Kitemark from 'components/Kitemark';

const PREFIX = 'KitemarkModal';

const classes = {
  modal: `${PREFIX}-modal`,
  paper: `${PREFIX}-paper`
};

const Root = styled('div')(() =>
  ({
    [`& .${classes.modal}`]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    [`& .${classes.paper}`]: {
      outline: 'none',
      borderRadius: 150
    }
  }));

interface Props {
  open: boolean;
}

export default function KitemarkModal(props: Props): JSX.Element {

  const { open } = props;
  const [show, setShow] = React.useState(true);

  const handleClose = () => {
    setShow(false);
  };

  return (
    <Root>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={classes.modal}
        open={open && show}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className={classes.paper}>
          <Kitemark
            helpText="You've nearly got your"
            title="level 1"
            subTitle="Atlas Kitemark!"
          />
        </div>
      </Modal>
    </Root>
  );
}
